import { CREATE_REVIEWS, ERR_REVIEWS } from "actions/types";
export default (state = null, action) => {
  switch (action.type) {
    case CREATE_REVIEWS:
      return {
        alert: {
          message: "Yorumunuz başarıyla gönderildi!",
          type: "success"
        }
      };
    case ERR_REVIEWS:
      return {
        alert: {
          message: "Onaylama Hatası !",
          type: "err"
        }
      };
    default:
      return state;
  }
};
